import { Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';
import { AccountContactComponent } from '@shared/components/account-contact/account-contact.component';
import { ChangeAccountComponent } from '@shared/components/change-account/change-account.component';

import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    RouterLinkActive,
    AccountContactComponent,
    ChangeAccountComponent,
    KENDO_LOADER,
    KENDO_BUTTON,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  // Services
  authService = inject(AuthService);

  // Input variables
  isAuthenticated = input<boolean>(false);
  userName = input<string>('');
  selectedAccount = this.authService.selectedAccount; // Auto updating signal

  accountName = computed(() => {
    const acct = this.selectedAccount();
    if (!acct) return 'SELECT ORG';
    return `ORG - ${acct.name}${acct.serialNumber ? ` (${acct.serialNumber})` : ''}`;
  });

  statusText = computed(() => {
    const user = this.userName();
    return user ? `${user} - ${this.logInText}` : this.logInText;
  });

  // Local variables
  logInText = 'Log Out';
  logoutClicked = false;
  showChangeAccount = false;
  showAccountContacts = false;

  protected async logout(): Promise<void> {
    // Terminated the session with Okta and removes current tokens.
    // Also removes local session data.
    await this.authService.signOut();
  }

  async changeAccount() {
    this.showChangeAccount = true;
  }

  openAccountContacts(): void {
    this.showAccountContacts = true;
  }

  closeAccountContacts(): void {
    this.showAccountContacts = false;
  }
}
